// SVW grade/variant sync (25 Aug 2026, grade-selector build).
// 1) On Dawn's variant-change, swap the custom PDP blocks ([data-svw-swap] in
//    svw-pp-top / svw-pp-mid) from the section HTML Dawn already fetched — the
//    server-rendered Liquid stays the single source of pricing truth (price row,
//    stock dot, hurry bar, BUY-N tier prices, per-piece infobox, grade pill).
// 2) Hosts the delegated handlers that used to be inline in those snippets —
//    inline scripts don't re-execute after an innerHTML swap.
(function () {
  // BUY-N bundle tiers (was inline in svw-pp-top.liquid)
  document.addEventListener('change', function (e) {
    var lbl = e.target && e.target.closest ? e.target.closest('.svw-pp-bundle') : null;
    if (!lbl) return;
    var wrap = lbl.closest('.svw-pp-bundles');
    if (!wrap) return;
    wrap.querySelectorAll('.svw-pp-bundle').forEach(function (l) { l.classList.remove('is-active'); });
    lbl.classList.add('is-active');
    var q = parseInt(lbl.dataset.qty, 10);
    var qtyInput = document.getElementById('svw-qty-input');
    if (qtyInput) qtyInput.value = q;
    var inv = parseInt(wrap.dataset.inv, 10);
    var warn = document.querySelector('.svw-pp-stockwarn');
    var short = q > inv;
    if (warn) warn.hidden = !short;
    var btn = document.querySelector('.product-form__submit');
    if (btn) btn.disabled = short;
  });

  // Product Info / Grading tabs (was inline in svw-pp-mid.liquid)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.svw-pp-tab') : null;
    if (!btn) return;
    document.querySelectorAll('.svw-pp-tab').forEach(function (b) { b.classList.remove('is-active'); });
    document.querySelectorAll('.svw-pp-tabpanel').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
    var panel = document.querySelector('[data-svwpanel="' + btn.dataset.svwtab + '"]');
    if (panel) panel.classList.add('is-active');
  });

  // Swap custom blocks when the selected variant changes
  function armSwap() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var html = event && event.data && event.data.html;
      if (!html || !html.querySelector) return;
      document.querySelectorAll('[data-svw-swap]').forEach(function (el) {
        var src = html.querySelector('[data-svw-swap="' + el.getAttribute('data-svw-swap') + '"]');
        if (src) el.innerHTML = src.innerHTML;
      });
    });
    return true;
  }
  // pubsub.js loads deferred alongside this file; retry briefly if it lands later
  if (!armSwap()) {
    var tries = 0;
    var t = setInterval(function () {
      if (armSwap() || ++tries > 20) clearInterval(t);
    }, 250);
  }
})();
